import type { RatingDefinition } from "./core";

export const ratingButtonDescription = (
  option: RatingDefinition["options"][number],
): string =>
  option.displayLabel && option.label.trim() !== String(option.value)
    ? option.label
    : "";
